import React from "react";
import { Paper, Typography, Box, useTheme, Tooltip, Chip, alpha } from "@mui/material";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

interface Props {
  label: string;
  value: string | number;
  delta?: number | null; // growth %, positive or negative
  helper?: string; // tooltip text
  median?: boolean;
}

const KpiCard: React.FC<Props> = ({ label, value, delta, helper, median }) => {
  const theme = useTheme();
  const positive = delta !== undefined && delta !== null && delta >= 0;

  const chipColor = positive ? theme.palette.success : theme.palette.error;

  return (
    <Tooltip title={helper ?? ""}>
      <Paper
        elevation={1}
        sx={{
          p: 1.25,
          display: "flex",
          flexDirection: "column",
          height: "100%",
          borderRadius: 3,
          justifyContent: "space-between",
        }}
      >
        <Typography
          variant="caption"
          color="text.primary"
          sx={{ mb: 0.5 }}
        >
          {label}
        </Typography>
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 2 }}>
          <Typography
            variant="subtitle1"
            fontWeight={600}
            sx={{ color: "#255272" }}
          >
            {value}
          </Typography>

          {delta !== undefined && delta !== null && !median && (
            <Chip
              size="small"
              variant="filled"
              sx={{
                height: 20,
                fontSize: "0.675rem",
                bgcolor: alpha(chipColor.main, 0.15),
                color: alpha("#229958", 0.9),
              }}
              icon={
                positive ? (
                  <ArrowDropUpIcon sx={{ fontSize: 18 }} />
                ) : (
                  <ArrowDropDownIcon sx={{ fontSize: 18 }} />
                )
              }
              label={`${positive ? "+" : "−"}${Math.abs(delta).toFixed(1)} %`}
            />
          )}
        </Box>
      </Paper>
    </Tooltip>
  );
};

export default KpiCard;
